module.exports = __webpack_public_path__ + "img/embassy_suites.51ba0fe0.png";